export { default as Watermark } from './Watermark';
